var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-header"},[_c('img',{staticClass:"logo-img",attrs:{"src":require("../assets/images/bloom_logo.svg")}}),_c('h2',{staticClass:"mb-30 mt-3"},[_vm._v(_vm._s(_vm.header))])])}
var staticRenderFns = []

export { render, staticRenderFns }